import $ from 'jquery';
import carousels from '../framework/carousel';

$('.media-carousel').each((index, item) => {
  const $carousel = $(item);
  const parentId = $carousel.attr('id');
  const customSettings = $carousel.data();

  const settings = {
    autoplay: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    ...customSettings,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  // Unconditionally initialize any media-carousel__slides
  const slidesSelector = `#${parentId} .media-carousel__slides`;
  if ($(slidesSelector).length) {
    carousels(slidesSelector, settings);
  }

  // Optional legacy support: if still using separate image/content carousels (pre-refactor)
  const hasSeparateTracks =
    $(`#${parentId}-images`).length && $(`#${parentId}-content`).length;

  if (hasSeparateTracks) {
    carousels(`#${parentId}-images`, {
      ...settings,
      asNavFor: `#${parentId}-content`,
    });

    carousels(`#${parentId}-content`, {
      ...settings,
      asNavFor: `#${parentId}-images`,
      arrows: false,
    });
  }
});
